import { useEffect, useState } from "react"
import { countryCodeMap, getCountryCodeMap, lang } from "../../../../constants/languages"
import { countryMapEn } from "../../../../constants/languages/countryMap/en"
import { countryIcons } from "../../../../constants"
//@ts-ignore
import EarthIcon from "../../../../assets/country-icons/earth.svg"
import { KSpan, KTitleSpan, KTooltip } from "kahuna-base-react-components"
import { formatNumber } from "../../../../utility"

const TopCountries = ({ trendCountryStreamMap }: { trendCountryStreamMap: { [key: string]: number } }) => {
  const [data, setData] = useState<{ country: string; streams: number; percent: number; icon: string }[]>([])
  //const [otherCountries, setOtherCountries] = useState<{ country: string; streams: number; percent: number; icon: string }[]>([])
  const countryMap = getCountryCodeMap()
  
 useEffect(() => {
   const rows = Object.entries(trendCountryStreamMap || {}).map(([country, streams]) => ({
     country,
     streams: Number(streams) || 0
   }))

   if (!rows.length) {
     setData([])
     return
   }

   rows.sort((a, b) => b.streams - a.streams)

   const total = rows.reduce((sum, r) => sum + r.streams, 0)
   if (total <= 0) {
     setData([])
     return
   }

   const top9 = rows.slice(0, 9)
   const rest = rows.slice(9)
   const otherStreams = rest.reduce((sum, r) => sum + r.streams, 0)

   const items = otherStreams > 0 ? [...top9, { country: "Other", streams: otherStreams }] : [...top9]

   let accumulatedPercent = 0

   const final = items.map((r, i) => {
     const countryKey = r.country as keyof typeof countryCodeMap
     const countryMap = countryMapEn
     const countryName = countryMap[countryKey]
     const icon: string = countryIcons[countryName as keyof typeof countryIcons] || EarthIcon

     if (i < items.length - 1) {
       const percent = Number(((r.streams / total) * 100).toFixed(1))
       accumulatedPercent += percent

       return {
         country: countryKey,
         streams: r.streams,
         icon,
         percent
       }
     }

     const percent = Number((100 - accumulatedPercent).toFixed(1))

     return {
       country: countryKey,
       streams: r.streams,
       icon,
       percent
     }
   })

   setData(final)
 }, [trendCountryStreamMap])
 
  return (
    <div
      className="w-full flex flex-col"
      style={{
        height: "100%",
        padding: 10,
        borderRadius: "10px",
        border: "1px solid var(--stroke-soft-200, #F3F3F3)",
        background: " var(--bg-white-0, #FFF)",
        boxShadow: "0px 2px 4px 0px rgba(27, 28, 29, 0.04)"
      }}
    >
      <div style={{ width: "100%", height: "5%", paddingLeft: 12, paddingTop: 4 }}>
        <KTitleSpan
          text={lang.analytics.audience.top_countries}
          fontSize={16}
          color="#737373"
          lineHeight="20px"
          fontWeight={500}
        />
      </div>
      <div style={{ width: "100%", height: "95%", padding: "20px" }} className="flex mt-4 flex-col gap-2">
        {data.map((item, index) => {
          const countryName =  item.country === "nan" ? "Unknown" : countryMap[item.country as keyof typeof countryCodeMap]
          return (
            <div key={item.country} className="flex flex-row w-full items-center justify-between">
              <div className="flex flex-row items-center">
                <div className="min-w-4">
                  <KSpan text={`${(index + 1).toString()}.`} fontWeight={600} color="#111" />
                </div>
                <img src={item.icon} className="w-5 h-5 min-w-5 min-h-5 mr-1" />

                <div className="max-[999px]:hidden">
                  <KSpan
                    text={
                      item.country === "Other"
                        ? lang.common.other_countries
                        : countryName || item.country
                    }
                    fontWeight={600}
                    color="#111"
                  />
                </div>
                <div className="min-[1000px]:hidden">
                  <KTooltip content={item.country === "nan" ? "Unknown" : null}>
                    <KSpan text={item.country === "nan" ? "UNK" : item.country} fontWeight={600} color="#111" />
                  </KTooltip>
                </div>
              </div>
              <div className="flex flex-row items-center gap-2 w-[70%] min-[1000px]:!w-[80%] shrink-0">
                <div className="min-w-12">
                  <KSpan text={formatNumber(item.streams)} />
                </div>
                <div
                  className="flex flex-1 relative"
                  style={{
                    backgroundColor: "#F3F3F3",
                    borderRadius: 20,
                    height: 20
                  }}
                >
                  <div
                    className="flex h-full"
                    style={{
                      borderRadius: 20,
                      width: `${item.percent}%`,
                      minWidth: 8,
                      backgroundColor: "#28AF60" //alternative color: 7C2DFC
                    }}
                  />
                </div>
                <div className="min-w-12">
                  <KSpan text={`${item.percent}%`} />
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default TopCountries
